export default __webpack_public_path__ + "static/media/qr-mobile.d9150dd2.jpg";